import { getLQTeamInfo, getPlayerBase } from "@/api/team.js"
export default {
    state: {
        teamInfo: null,
        playerInfo: null
    },
    mutations: {
        test (state, action) {
            state.isDark = action
        },
        updateGetLQTeamInfo (state, data) {
            state.teamInfo = data
        },
        updateGetPlayerBase (state, data) {
            state.playerInfo = data
        }
    },
    actions: {
        // 篮球球队基本信息
        async getLQTeamInfo ({ commit }, params) {
            const res = await getLQTeamInfo(params)
            if (res.errno === 0) {
                commit("updateGetLQTeamInfo", res.data)
            }
        },
        // 篮球球员基本信息
        async getPlayerBase ({ commit }, params) {
            const res = await getPlayerBase(params)
            if (res.errno === 0) {
                commit("updateGetPlayerBase", res.data)
            }
        }
    }
}
